import React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { postRequestcall } from '../util/postRequest'
import { UPDATE_LAT_LNG } from '../../constants/apiurl'

export default function VerifyUserLiveLocation() {
    const { logindata, access_token } = useSelector((state)=>state?.login)
    useEffect(()=>{
        if(logindata?.vendor_type === "driver" && access_token){
            const intervalId = setInterval(() => {
                callSetUpdateLocation()
            }, 45000);
            return () => clearInterval(intervalId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[logindata?.vendor_type, access_token])
    const callSetUpdateLocation = () =>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callUpdateLatLngAPI, fetchError);
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    }
    const callUpdateLatLngAPI = async (position) => {
        const { latitude, longitude } = position.coords;
        const payload = {
            current_lat:latitude,
            current_lng:longitude,
        }
        await postRequestcall(UPDATE_LAT_LNG, access_token, payload);
    }

    const fetchError = (error) => {
        console.error('Error getting current location:', error);
    }
  return (
    <React.Fragment>
      
    </React.Fragment>
  )
}
